
<ul>
    <li *ngFor="let menu of sideBarSettings" >
        <a  class="link-menu"
            [routerLink]="menu.route"
            routerLinkActive="active">
            {{ menu.txt | translate}}
        </a>
    </li>
</ul>